import { HttpErrorResponse, HttpEvent, HttpInterceptorFn, HttpRequest, HttpResponse } from '@angular/common/http';
import { authControl } from '../config/ulit';
import { catchError, map, throwError } from 'rxjs';
import { HttpError } from '../config/Httperror';
export const headerInterceptor: HttpInterceptorFn = (req, next) => {


    const apiKey = sessionStorage.getItem(authControl.tditAccuss);


    const authReq = req.clone({
        setHeaders: {
            // 'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Methods': 'GET, PUT, POST, DELETE',
            'Access-Control-Allow-Headers': 'Content-Type, x-requested-with',
            Authorization: `Bearer ${apiKey}`,
            // "Content-Type": "Access-Control-Allow-Origin"
        },
    });

    // function authenticate<T>(req: HttpRequest<T>, token: string): HttpRequest<T> {
    //     return req.clone({
    //       setHeaders: {
    //         'Content-Type': 'application/json',
    //         'Access-Control-Allow-Origin': '*',
    //         'Access-Control-Allow-Methods': 'GET, PUT, POST, DELETE',
    //         'Access-Control-Allow-Headers': 'Content-Type, x-requested-with',
    //         'Authorization': `Bearer ${token}`
    //       },
    //       withCredentials: true
    //     }); }
    return next(authReq).pipe(
        catchError((err: any) => {
            switch (err?.status) {
                case 400:
                    console.log(12232);
                    break;
                case 404:
                    console.log(404);
                    break;
                default:
                    break;
            }

            return throwError(() => err)
        }),
        map((event: HttpEvent<any>) => {
            // Check if the event is an HTTP response
            if (event instanceof HttpResponse) {
                // Handle successful response here
                // console.log('Successful response:', event);
            }
            return event;
        })
    )





};
// return next(authReq).pipe(
//     catchError((err: any) => {
//         if (err instanceof HttpErrorResponse) {
//             // if (err.status === 401) {
//             //     if (window.location.hash.split("#")[1] !== "/login") {
//             //         window.location.href = "/login";
//             //     }
//             // }
//         }

//         return throwError(() => err);
//     })
// );